export default __webpack_public_path__ + "static/media/instagram-rose.1aabf26f.svg";